<template>
  <div  class="u-wrap">
      <!-- <dhzjgk-card :list="list"></dhzjgk-card> -->
      <!-- <div class="card">
        <div style="padding: 12px 12px 0 12px">
          <div class="card-top">
            <div class="xm">
              <img src="@images/xxgk/icon-user.png" />
              {{ xm }}
            </div>
            <div class="sfzh">{{ sfzh }}</div>
          </div>
          <div v-if="xmbmDictText" class="tags">
            <span v-for="(tag, index) in xmbmDictText.split(',')" :key="index" class="tag">{{ tag }}</span>
          </div>
        </div>
      </div> -->

      <div   @click="clickMenu('/xxgk/dhzjgk')">
        <img  src="@images/xxgk/bg-dhzjgk.png" class="img-bg"/>

      </div>
      <div   @click="clickMenu('/xxgk/dhzjgk-view1')">
            <img  src="@images/xxgk/bg-wddhzj.png" class="img-bg"/>
      </div>
    
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
   
    }
  },
  created() {
  
  },
  computed: {},
  methods: {
    clickMenu(path){
       this.$router.push({
        path:path,
      });
    }
  },
}
</script>

<style lang="less" scoped>
//  @import '../../assets/less/whon-theme.less';

.u-wrap {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  // background: #f5f5f5;
  background: #fff;
  padding: 12px;
}

.dhzjgk-top {
  background: #9fcfff;
  padding-top: 16px;
}

.dhzjgk-content {
  // flex: 1;
  padding-top: 12px;
  background: #fff;
  // overflow-y: scroll;
}

.card {
  border-radius: 8px;
  min-height: 50px;
  background: #fff;
  overflow: hidden;

  .card-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;

    .xm {
      display: flex;
      align-items: center;
    }

    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }

  .tags {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 6px;

    .tag {
      display: inline-block;
      background: #ecf5ff;
      border-radius: 6px;
      padding: 3px 6px;
      color: #4d9bfd;
      border: 1px solid #4d9bfd;
      margin-bottom: 8px;
      font-size: 13px;
      margin-right: 10px;
    }
  }

  .card-bottom {
    border-top: 1px solid #dedede;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 15px;
  }

  .card-bottom:active {
    background: #dedede;
  }
}

.sticky {
  position: sticky;box-shadow: 0 -1px #FFFFFF;top: 0;z-index:1
}

.img-bg{
  width: 100%;
  height: auto;
}
</style>
